import { lightTheme } from '@clds/themes';
const spacing = lightTheme.spacing;
export const theme = {
    bySize: {
        xxs: { width: spacing.xxs },
        xs: { width: spacing.xs },
        sm: { width: spacing.sm },
        md: { width: spacing.md },
        lg: { width: spacing.lg },
        xl: { width: spacing.xl },
        xxl: { width: spacing.xxl },
    },
};
export const iconNextSizeVariant = (size) => theme.bySize[size];
//# sourceMappingURL=theme.js.map